import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
// import Navbar from "../../components/navbar/Navbar";
// import Footer from "../../components/footer/Footer";
// import Header from "../../components/header/Header";
import { FaMinus, FaPlus } from "react-icons/fa";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  calculateDiscountedPrice,
  renderStars,
  // convertCurrency,
  // getConvertedPrice,
} from "../../utils/functions";
import { IoIosArrowDown } from "react-icons/io";
import SimilarProducts from "../../components/similarProducts/SimilarProducts.tsx";
import { getFetcher, postFetcher } from "../../../api/fetchers.ts";
import { endpoints } from "../../../api/endpoints.ts";
import Spinner from "../../components/spinner/Spinner.tsx";
import { formatISODate } from "../../utils/functions.tsx";
import Modal from "react-modal";
import { IoIosFlash } from "react-icons/io";
import { FaHotjar } from "react-icons/fa";
import { Tooltip } from "flowbite-react";
import { MdChevronRight } from "react-icons/md";
import { useProduct } from "../../context/ProductContext.tsx";
import { CgAwards } from "react-icons/cg";
import ProductIntroduction from "../../components/productIntroduction/ProductIntroduction.tsx";
import { useUser } from "../../context/UserContext.tsx";
import Label from "../../assets/images/label.png";
import Truck from "../../assets/images/about-truck.png";
import Ticket from "../../assets/images/about-ticket.png";
import Basket from "../../assets/images/about-basket.png";
// import PaymentPro from "../../assets/images/payment_pro.png";
import Hand from "../../assets/images/handok.png";
import Tick from "../../assets/images/tick.png";
import Surf from "../../assets/images/surf.png";
import { parseStatics } from "../../function/parseStatics.tsx";
// import calculateBusinessPackage from '../../function/CalcBusinessPackage.tsx';
// import { FaCheck } from "react-icons/fa";
import { GoDot, GoDotFill } from "react-icons/go";
import styles from "./ProductDetail.module.css";
import { useLanguage } from "../../context/LanguageContext.tsx";
import { useCurrency } from "../../context/CurrencyContext";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import { Helmet } from "react-helmet-async";
import { FaRegWindowClose } from "react-icons/fa";
import { FaChevronRight, FaChevronLeft } from "react-icons/fa";

interface IProductIntroduction {
  productId: string;
  firstText: string;
  secondText: string;
  images: string[];
  videoLink: string;
}

interface B2B {
  id: string | number | any;
  name: string;
  ratio: number;
}

const ProductDetail: React.FC = () => {
  const { t } = useLanguage();
  const { exchangeRate, currencySymbol } = useCurrency();
  const { productId } = useParams<{ productId: string }>();
  const [product, setProduct] = useState<any>({});
  const [totalDiscountedPrice, setTotalDiscountedPrice] = useState<number>(0);
  const [productDiscount, setProductDiscount] = useState<number>(0);
  const [totalPrice, setTotalPrice] = useState<number>(0);
  const [quantity, setQuantity] = useState(1);
  const [mainImage, setMainImage] = useState("");
  const [reviews, setReviews] = useState<any[]>([]);
  const [isDropdownOpen, setIsDropdownOpen] = useState<{
    [key: string]: boolean;
  }>({});
  const [selectedAttributes, setSelectedAttributes] = useState<{
    [key: string]: string;
  }>({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalImage, setModalImage] = useState("");
  const [activeBulkDiscount, setActiveBulkDiscount] = useState<number | null>();
  const [bulkPrice, setBulkPrice] = useState<any>();
  const [bulkDefaultPrice, setBulkDefaultPrice] = useState<any>();
  const [bulkDiscountRate, setBulkDiscountRate] = useState<any>();
  const [isWeeklyProduct] = useState<boolean>(false);
  const [isBulkDiscount, setIsBulkDiscount] = useState(false);
  const [userBusinessPackage, setUserBusinessPackage] = useState<B2B>();
  const [descriptionShow, setDescriptionShow] = React.useState(true);
  // const [convertedPrice, setConvertedPrice] = useState<string | null>(null);
  const { user } = useUser();
  const [productIntroduction] = useState<IProductIntroduction>({
    productId: "",
    firstText: "",
    secondText: "",
    images: [],
    videoLink: "",
  });
  const [showProductIntroductions] = useState(false);
  const [showSizeModal, setShowSizeModal] = useState<boolean>(false);
  const [sizeModalImage, setSizeModalImage] = useState<any>(null);
  const modalRef = useRef<any>(null);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isOpen, setIsOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(1);
  const [loadingBusinessPackage, setLoadingBusinessPackage] =
    useState<boolean>(true);
  const [retailStatus] = useState(localStorage.getItem('rst') == "6535" ? true : false);

  const { changeBulkDiscountStatus } = useProduct();

  const handleClickOutside = (event: any) => {
    if (modalRef.current && !modalRef.current.contains(event.target)) {
      setShowSizeModal(false);
    }
  };

  useEffect(() => {
    if (showSizeModal) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showSizeModal]);

  const handleAttributeChange = (attribute: string, value: string) => {
    setSelectedAttributes((prevAttributes) => ({
      ...prevAttributes,
      [attribute]: value,
    }));
    setIsDropdownOpen((prevState) => ({
      ...prevState,
      [attribute]: false,
    }));
  };

  const toggleDropdown = (dropdownKey: string) => {
    setIsDropdownOpen((prevState) => ({
      ...prevState,
      [dropdownKey]: !prevState[dropdownKey],
    }));
  };

  const resetState = () => {
    setSelectedAttributes({});
    setQuantity(1);
  };

  const fetchProduct = async () => {
    try {
      const productResponse = await getFetcher(
        endpoints.products.getProductById.replace("{id}", productId || "")
      );
      if (
        productResponse &&
        productResponse.product &&
        productResponse.product.product.images
      ) {
        setProduct(productResponse.product);
        const images = productResponse.product.product.images;
        setMainImage(images[2]);
        setSizeModalImage(images[1]);
        resetState();
      } else {
        toast.error(productResponse.message || "");
      }
    } catch (error) {
      console.error("Error fetching product:", error);
      toast.error(t("toastMessage", "pdErr"));
    }

    try {
      const reviewsResponse = await getFetcher(
        endpoints.products.getProductReviews.replace(
          "{productId}",
          productId || ""
        )
      );
      if (reviewsResponse && reviewsResponse.productEvaluations) {
        setReviews(reviewsResponse.productEvaluations);
      } else if (reviewsResponse.productEvaluations?.length === 0) {
        toast.error(t("toastMessage", "pdCommentErr"));
      }
    } catch (error: any) {
      console.error("Error fetching reviews:", error);
    }
  };

  const fetchBusinessPackageData = async () => {
    if (user) {
      try {
        const businessPackage = await getFetcher(
          endpoints.user.getBusinessPackageById.replace(
            "{id}",
            user.businessPackageId
          )
        );
        if (businessPackage.result) {
          setUserBusinessPackage(businessPackage.businessPackage);
        }
      } catch (error) {
        console.error("Error fetching business package:", error);
      } finally {
        setLoadingBusinessPackage(false);
      }
    } else {
      // If no user is present, directly set loading to false
      setLoadingBusinessPackage(false);
    }
  };

  useEffect(() => {
    fetchBusinessPackageData();
  }, [user]);

  // FORMAT COMPANY-VALUE
  const formatCompanyValue = (value: any) => {
    if (typeof value === "string" && value.includes("/")) {
      const [number, fraction] = value.split("/");
      return `${number} + ${fraction}MF`;
    }
    return "";
  };

  useEffect(() => {
    if (productId) {
      fetchProduct();
    }
  }, [productId]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  if (isLoading || !product || !product.product) {
    return <Spinner />;
  }

  // ADD TO CART
  const handleAddToCart = async () => {
    // @ts-ignore
    const localUserId = parseStatics(localStorage.getItem("defaultUserId"));

    const attributes = product.product.attributes;
    const requiredAttributes = Object.keys(attributes).filter(
      (key) => attributes[key].values && attributes[key].values.length > 0
    );

    if (Object.keys(selectedAttributes).length !== requiredAttributes.length) {
      toast.error(t("toastMessage", "pdAttrErr"));
      return;
    }

    /*if (quantity > product.product.stock) {
 toast.error('Stokta yeterli ürün bulunmamaktadır');
 return;
 }*/

    let userId;

    if (user) {
      userId = user.id;
    } else if (localUserId) {
      userId = localUserId;
    } else {
      userId = "";
    }

    try {
      const response = await postFetcher(endpoints.user.addProductBasket, {
        arg: {
          userId,
          productId: productId,
          quantity: Number(quantity),
          attributes: selectedAttributes,
          bulkDiscount: isBulkDiscount,
          businessPackageId: user ? user.businessPackageId : "10",
        },
      });

      if (!localUserId && !user) {
        localStorage.setItem(
          "defaultUserId",
          JSON.stringify(response.basketItem.userId)
        );
      }

      if (response.result) {
        toast.success(
          `${product.product.name} ${t("toastMessage", "addBasketCartSuc")}`
        );
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      } else {
        toast.error(t("toastMessage", "addBasketCartErr"));
      }
    } catch (error) {
      console.error("Error adding product to basket:", error);
      toast.error(t("toastMessage", "addBasketCartErr"));
    }
  };

  // calculate price by quantity
  const handleQuantityChange = (amount: number, type: number) => {
    setQuantity((prevQuantity) => {
      let newQuantity: number;

      if (type === 1) {
        newQuantity = Math.max(1, Number(prevQuantity) + amount);
      } else if (type === 2) {
        newQuantity = amount;
      } else {
        newQuantity = 1;
      }

      const applicableDiscount = bulkDiscountsArray
        .filter((discount: any) => newQuantity >= discount.quantity)
        .sort((a: any, b: any) => b.quantity - a.quantity)[0];

      if (applicableDiscount) {
        const { quantity: discountQuantity, discount: discountAmount } =
          applicableDiscount;
        const totalPrice =
          calculateDiscountedPrice(
            product.product.price,
            product.product.discount,
            userBusinessPackage ? userBusinessPackage?.ratio : 0,
            exchangeRate
          ) * newQuantity;
        const totalDiscountAmount = discountAmount * newQuantity;
        const bulkPrice = (totalPrice - totalDiscountAmount).toFixed(1);
        const discountRate =
          totalPrice > 0
            ? ((totalDiscountAmount / totalPrice) * 100).toFixed(1)
            : "0";

        setBulkDiscountRate(discountRate);
        setBulkDefaultPrice(totalPrice?.toFixed(1));
        setBulkPrice(bulkPrice);

        const activeIndex = bulkDiscountsArray.findIndex(
          (discount: any) => discount.quantity === discountQuantity
        );
        setActiveBulkDiscount(activeIndex);
      } else {
        setTotalDiscountedPrice(
          calculateDiscountedPrice(
            product.product.price,
            product.product.discount,
            userBusinessPackage ? userBusinessPackage?.ratio : 0,
            exchangeRate
          ) * newQuantity
        );
        setTotalPrice(product.product.price * newQuantity);
        setProductDiscount(product.product.discount);
        setBulkPrice(null);
        setActiveBulkDiscount(null);
        setIsBulkDiscount(false);
      }
      return newQuantity;
    });
  };
  const handleImageClick = (image: string) => {
    setMainImage(image);
  };

  const handleReviewImageClick = (image: string) => {
    setModalImage(image);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const bulkDiscountsArray = (product?.product?.bulkDiscounts || []).map(
    (item: any) => ({
      quantity: item.quantity,
      discount: item.discount,
    })
  );

  const handleClickBulkDiscount = (index: number, discount: any) => {
    setActiveBulkDiscount(index);
    setQuantity(bulkDiscountsArray[index].quantity);
    setIsBulkDiscount(true);
    changeBulkDiscountStatus();

    const calculateBulkDiscountedPrice = (
      quantity: number,
      price: number,
      discountQuantity: number,
      discountPercentage: number
    ) => {
      if (quantity >= discountQuantity) {
        const totalPrice = price * quantity;
        const totalDiscountAmount = (totalPrice * discountPercentage) / 100; // Yüzde indirimi hesaplandı
        const bulkPrice = (totalPrice - totalDiscountAmount).toFixed(1);
        const discountRate =
          totalPrice > 0 ? (totalDiscountAmount / totalPrice) * 100 : 0;
        setBulkDiscountRate(discountRate.toFixed(1));
        setBulkDefaultPrice(totalPrice.toFixed(1));
        return bulkPrice;
      } else {
        setIsBulkDiscount(false);
        return price * quantity;
      }
    };

    // İndirimli ürün fiyatını hesapla
    const productDiscountPrice: number | any = calculateDiscountedPrice(
      product.product.price,
      product.product.discount,
      userBusinessPackage ? userBusinessPackage?.ratio : 0,
      exchangeRate
    );

    // Yüzde indirimi kullanarak bulk fiyatı hesapla
    const bulkPrice = calculateBulkDiscountedPrice(
      bulkDiscountsArray[index].quantity,
      productDiscountPrice,
      discount?.quantity,
      discount?.discount // Şimdi bu yüzde değeri olarak kabul ediliyor
    );

    setBulkPrice(bulkPrice);
  };

  // CALCULATE CAMPAİGN PRİCE
  const calculateCampaignPrice = (item: any) => {
    let total: any;

    if (item.companyCampaign) {
      if (item.companyCampaign.companyCampaignTypeId === 3) {
        total =
          calculateDiscountedPrice(
            item.product.price,
            item.product.discount,
            userBusinessPackage ? userBusinessPackage?.ratio : 0,
            exchangeRate
          ) - item.companyCampaign.companyValue;
        return total;
      }
    }

    if (item.dailyCampaign) {
      if (item.dailyCampaign.dailyCampaignTypeId === 3) {
        total =
          calculateDiscountedPrice(
            item.product.price,
            item.product.discount,
            userBusinessPackage ? userBusinessPackage?.ratio : 0,
            exchangeRate
          ) - item.dailyCampaign.dailyValue;
        return total;
      }
    }

    return calculateDiscountedPrice(
      item.product.price,
      item.product.discount,
      userBusinessPackage ? userBusinessPackage?.ratio : 0,
      exchangeRate
    );
  };

  const featureNaming = (key: string) => {
    switch (key) {
      case "Color":
        return t("productDetail", "colorS");
      case "Size":
        return t("productDetail", "bodyS");
      case "Weight":
        return t("productDetail", "weightS");
      case "Ml":
        return t("productDetail", "mlS");
      default:
        return "";
    }
  };

  const filteredImages = product.product.images.filter((_: any, index: any) => {
    if (index === 1 || index === 0) {
      return false;
    }
    return true;
  });

  const originalPrice = product.product.price * exchangeRate;

  const calculatePrice = (
    price: number,
    discount: number,
    ratio: number
  ): any => {
    return calculateDiscountedPrice(
      price,
      discount,
      ratio,
      exchangeRate
    ).toFixed(1);
  };

  return (
    <div className="flex flex-col min-h-screen overflow-hidden">
      <Helmet>
        {/* <title>{t("productDetail", "metaTitle")}</title> */}
        <meta
          name="keywords"
          content={product?.product?.keywords || "Default, Keywords"}
        />
        <meta
          name="description"
          content={
            product?.product?.description || "Bu sayfa ürün detaylarını içerir."
          }
        />
      </Helmet>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      {/* <Header />
      <Navbar /> */}
      <main className="flex-grow overflow-y-auto">
        <div className="max-w-[1400px] mx-auto bg-white rounded-lg p-6 bg">
          <div className="flex justify-start items-center gap-x-0 clear-start text-xxs sm:text-xs font-semibold text-color-bold-gray mb-4">
            <div className=" select-none">
              {product.product.ProductCategory.name}
            </div>
            <div>
              <MdChevronRight size={20} />
            </div>
            <div className=" select-none">
              {product.product.ProductSubCategory.name}
            </div>
          </div>
          {/* PRODUCT DETAILS */}
          <div className="flex flex-col lg:flex-row justify-between">
            {/*PRODUCT IMAGES*/}
            <div className="w-full lg:w-[40%] relative">
              {/* MAIN IMAGE */}
              <div className="flex justify-center items-start relative select-none w-full cursor-pointer">
                <img
                  src={mainImage}
                  alt={product.product.name}
                  loading="lazy"
                  className="object-cover rounded-lg shadow-md h-[350px] md:!h-[650px] w-full"
                  onClick={() => setIsOpen(true)}
                />

                {/* Left Arrow */}
                <button
                  className="absolute group left-4 top-1/2 transform -translate-y-1/2 text-white text-xl bg-primary-color/90 p-2 rounded hover:bg-yellow-color transition-all"
                  onClick={() => {
                    setPhotoIndex((prev) => {
                      let prevIndex =
                        (prev - 1 + filteredImages?.length) %
                        filteredImages?.length;
                      setMainImage(filteredImages[prevIndex]);
                      return prevIndex;
                    });
                  }}
                >
                  <FaChevronLeft className="text-yellow-color group-hover:text-primary-color transition-all" />
                </button>

                {/* Right Arrow */}
                <button
                  className="absolute group right-4 top-1/2 transform -translate-y-1/2 text-white text-xl bg-primary-color/90 p-2 rounded hover:bg-yellow-color transition-all"
                  onClick={() => {
                    setPhotoIndex((prev) => {
                      let nextIndex = (prev + 1) % filteredImages?.length;
                      setMainImage(filteredImages[nextIndex]);
                      return nextIndex;
                    });
                  }}
                >
                  <FaChevronRight className="text-yellow-color group-hover:text-primary-color transition-all" />
                </button>
              </div>

              {/* DOTS */}
              <div className="flex flex-row justify-center order-last lg:order-first gap-4">
                {filteredImages.map((img: string, index: number) =>
                  mainImage === img ? (
                    <GoDotFill
                      key={index}
                      size={23}
                      onClick={() => {
                        handleImageClick(img);
                        setPhotoIndex(index);
                      }}
                      className="cursor-pointer mt-4 text-yellow-color"
                    />
                  ) : (
                    <GoDot
                      key={index}
                      size={23}
                      onClick={() => {
                        handleImageClick(img);
                        setPhotoIndex(index);
                      }}
                      className="cursor-pointer mt-4"
                    />
                  )
                )}
              </div>
            </div>

            {/* PRODUCT INFO */}
            <div className="w-full lg:w-[58%] flex flex-col gap-4">
              <div className=" flex justify-between items-center ">
                <h1 className="text-2xl sm:text-3xl font-medium text-gray-800">
                  {product.product.name}
                </h1>

                {/* ISFLASH ISFEATURED ISWEEKLYPRODUCT ICONS*/}
                <div className=" min-w-10 md:min-w-24">
                  <div className=" flex gap-x-3 justify-center items-center">
                    {product.product.isFlash && (
                      <div>
                        <Tooltip content="Flaş Ürün">
                          <IoIosFlash
                            size={25}
                            className=" text-primary-color cursor-pointer "
                          />
                        </Tooltip>
                      </div>
                    )}
                    {product.product.isFeatured && (
                      <div>
                        <Tooltip content="Öne Çıkan Ürün">
                          <FaHotjar
                            size={20}
                            className=" text-primary-color cursor-pointer "
                          />
                        </Tooltip>
                      </div>
                    )}
                    {isWeeklyProduct && (
                      <div>
                        <Tooltip content="Haftanın Ürünü">
                          <CgAwards
                            size={25}
                            className=" text-primary-color cursor-pointer "
                          />
                        </Tooltip>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/*RATING*/}
              <div className="flex items-center mt-2">
                {renderStars(product.product.rating)}
                <p className="text-xl mt-1 ml-2">
                  {product?.product?.rating} / 5
                </p>
              </div>

              <div className="flex items-center gap-1">
                {userBusinessPackage && userBusinessPackage?.id != "10" && (
                  <Tooltip
                    content={`Bu üründe üyelik paketiniz sayesinde ekstra %${userBusinessPackage?.ratio || 0
                      } indirim kazanıyorsunuz.`}
                    style="light"
                  >
                    <div className="w-16 h-5 flex items-center justify-center text-sm bg-green-200 text-green-500 px-4 rounded font-bold select-none">
                      <p className="text-green-500 mr-1">B:</p>{" "}
                      <p>%{userBusinessPackage?.ratio}</p>
                    </div>
                  </Tooltip>
                )}
                <div className="w-full">
                  <span className="font-bold text-sm flex text-primary-color select-none ml-auto w-full">
                    {product.product.brand}
                  </span>
                </div>
              </div>

              {/*CODE*/}
              <div className="flex items-center">
                <span className="font-medium text-xl flex text-black select-none">
                  {t("productDetail", "productCode")} :{" "}
                  {product.product.code
                    ? product.product.code
                    : "Kod girilmemiş."}
                </span>
              </div>

              <div className="flex justify-between">
                <div className="bg-[#D9D9D9] items-center justify-center flex h-[20px] rounded-xl w-[22%] overflow-hidden">
                  <p className="text-[12px] font-rufina text-[#848484] whitespace-nowrap overflow-hidden text-ellipsis">
                    {t("productDetail", "t1")}
                  </p>
                </div>

                <div className="bg-[#D9D9D9] items-center justify-center flex h-[20px] rounded-xl w-[22%] overflow-hidden">
                  <p className="text-[12px] font-rufina text-[#848484] whitespace-nowrap overflow-hidden text-ellipsis">
                    {t("productDetail", "t2")}
                  </p>
                </div>

                <div className="bg-[#D9D9D9] items-center justify-center flex h-[20px] rounded-xl w-[22%] overflow-hidden">
                  <p className="text-[12px] font-rufina text-[#848484] whitespace-nowrap overflow-hidden text-ellipsis">
                    {t("productDetail", "t3")}
                  </p>
                </div>

                <div className="bg-[#D9D9D9] items-center justify-center flex h-[20px] rounded-xl w-[22%] overflow-hidden">
                  <p className="text-[12px] font-rufina text-[#848484] whitespace-nowrap overflow-hidden text-ellipsis">
                    {t("productDetail", "t4")}
                  </p>
                </div>
              </div>

              <div className="bg-[#EAEAEA] w-full p-4">
                {loadingBusinessPackage ? (
                  // Skeleton loader for the price section
                  <div className="flex flex-col items-start">
                    <div className="w-[120px] h-[20px] bg-gray-300 animate-pulse"></div>
                    <div className="w-[150px] h-[20px] bg-gray-300 animate-pulse mt-2"></div>
                  </div>
                ) : (
                  <div className="flex justify-between mb-2">
                    {
                      retailStatus ?
                        <span className="text-xl sm:text-3xl font-semibold text-primary-color flex flex-col items-start gap-y-2">
                          {product?.product?.discount ||
                            (userBusinessPackage &&
                              userBusinessPackage?.id !== "10") ? (
                            <span className="line-through text-gray-400 text-2xl font-rubik font-normal">
                              {currencySymbol}
                              {originalPrice.toFixed(1)}
                            </span>
                          ) : null}

                          {currencySymbol}
                          {calculatePrice(
                            product?.product?.price,
                            product?.product?.discount,
                            userBusinessPackage ? userBusinessPackage?.ratio : 0
                          )}
                        </span>
                        :
                        <span className="text-xl sm:text-3xl font-semibold text-primary-color flex flex-col items-start gap-y-2">

                        </span>
                    }
                    <img
                      src={Label}
                      className="h-[16px] w-[16px] hidden relative left-20 mt-[1px]"
                      alt="label"
                    />
                    <p className="text-[#FFC633] text-sm w-[58%] md:w-[65%] text-end font-bold">
                      {t("productDetail", "sub")}
                    </p>
                  </div>
                )}

                {
                  retailStatus ?
                    product?.product?.discount > 0 && !loadingBusinessPackage ?
                      <span className="text-lg sm:text-sm font-medium text-gray-500 flex gap-x-2">
                        {t("productDetail", "q3")}:
                        <p className="font-bold text-primary-color text-sm">
                          {currencySymbol}
                          {(
                            Number(
                              calculateDiscountedPrice(
                                product?.product?.price,
                                product?.product?.discount,
                                userBusinessPackage
                                  ? userBusinessPackage?.ratio
                                  : 0,
                                exchangeRate
                              )
                            ) * 3
                          ).toFixed(1)}
                        </p>
                      </span>
                      :
                      // Skeleton loader for the discounted price
                      <span className="text-lg sm:text-sm font-medium text-gray-500 flex gap-x-2">
                        {t("productDetail", "q3")}:
                        <p className="font-bold text-primary-color text-sm">
                          <span className="bg-gray-200 w-20 h-6 animate-pulse rounded-md"></span>
                        </p>
                      </span>
                    :
                    <></>
                }

                {/*ATTRIBUTE SELECTOR*/}
                {product.product.attributes && (
                  <div className="mt-4">
                    {Object.entries(product?.product?.attributes).map(
                      ([key, value]: [string, any]) => {
                        if (!value.values || value?.values.length === 0) {
                          return null;
                        }
                        return (
                          <div key={key}>
                            {key === "Size" && (
                              <div className="flex justify-end mb-2">
                                {sizeModalImage !== "" && (
                                  <button
                                    onClick={() => {
                                      if (key === "Size" || key === "Größe") {
                                        setShowSizeModal(true);
                                      }
                                    }}
                                    className="text-[14px] border-b-2 border-black hover:border-yellow-color font-semibold transform duration-300"
                                  >
                                    {t("productDetail", "body")}
                                  </button>
                                )}
                              </div>
                            )}
                            <label
                              className={`block text-black font-semibold mb-2 text-end`}
                            >
                              {featureNaming(key)}{" "}
                              {t("productDetail", "bodySelect")}
                            </label>
                            <div className="relative">
                              {key === "Color" ? (
                                <div className="flex flex-wrap gap-2">
                                  {value.values.map(
                                    (option: string, index: number) => (
                                      <div
                                        key={index}
                                        className={`w-7 h-7 rounded-full cursor-pointer border-2 ${selectedAttributes[key] === option
                                          ? "border-primary-color"
                                          : "border-gray-300"
                                          }`}
                                        style={{ backgroundColor: option }}
                                        onClick={() =>
                                          handleAttributeChange(key, option)
                                        }
                                      ></div>
                                    )
                                  )}
                                </div>
                              ) : (
                                <>
                                  <button
                                    type="button"
                                    className={`inline-flex justify-between w-full py-4 px-4 font-bold bg-[#D0D0D0] focus:outline-none shadow-sm sm:text-sm h-[36px] items-center ${selectedAttributes[key]
                                      ? "text-primary-color"
                                      : "text-color-bold-gray"
                                      }`}
                                    aria-expanded={isDropdownOpen[key]}
                                    aria-haspopup="true"
                                    onClick={() => toggleDropdown(key)}
                                  >
                                    {selectedAttributes[key] ||
                                      t("productDetail", "bodySelect")}
                                    <IoIosArrowDown className="ml-2 h-5 w-5 text-gray-400" />
                                  </button>
                                  {isDropdownOpen[key] && (
                                    <div className="absolute right-0 z-10 mt-2 w-full max-h-32 overflow-y-auto origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                                      <div className="py-1" role="none">
                                        {value.values.map(
                                          (option: string, index: number) => (
                                            <p
                                              key={index}
                                              className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 cursor-pointer"
                                              role="menuitem"
                                              onClick={() =>
                                                handleAttributeChange(
                                                  key,
                                                  option
                                                )
                                              }
                                            >
                                              <span
                                                className="inline-block w-4 h-4 mr-2 rounded"
                                                style={{
                                                  backgroundColor: option,
                                                }}
                                              ></span>
                                              <span>{option}</span>
                                            </p>
                                          )
                                        )}
                                      </div>
                                    </div>
                                  )}
                                </>
                              )}
                            </div>
                          </div>
                        );
                      }
                    )}
                  </div>
                )}

                <div className="flex items-center justify-center self-start gap-2 sm:gap-6 py-4 w-44 bg-transparent justify-self-center px-4 rounded-3xl">
                  <button onClick={() => handleQuantityChange(-1, 1)}>
                    <FaMinus size={14} />
                  </button>
                  <div className="flex justify-center items-center">
                    <input
                      className="w-[73px] min-w-[73px] h-7 p-2 font-semibold bg-[#D0D0D0] text-black text-center border-none rounded-full object-none"
                      type="text"
                      value={quantity}
                      onChange={(e: any) =>
                        handleQuantityChange(Number(e.target.value), 2)
                      }
                      onInput={(e: any) => {
                        e.target.value = e.target.value.replace(/[^0-9]/g, "");
                      }}
                    />
                  </div>
                  <button onClick={() => handleQuantityChange(1, 1)}>
                    <FaPlus size={14} />
                  </button>
                </div>

                <button
                  className="w-full sm:w-[70%] bg-[#FFC633] flex mx-auto items-center justify-center text-[#545454] px-10 h-[36px] font-semibold rounded-md shadow-sm hover:bg-primary-color-light focus:outline-none"
                  onClick={() => {
                    if (!retailStatus) {
                      toast.error(t('general', 'reqLogBasket'));
                    } else {
                      handleAddToCart();
                    }
                  }}
                >
                  {t("productDetail", "addButton")}
                </button>
              </div>

              {/*QUANTITY and ADD TO CART BUTTON*/}
              <div className="flex flex-col sm:flex-row items-center -mt-2 gap-6 sm:gap-12">
                {/* IN STOCK */}
                <div className=" font-light text-sm flex justify-end ml-auto select-none">
                  <div className=" flex gap-x-1 text-green-800 justify-center items-center">
                    <span className=" font-semibold">
                      {t("productDetail", "inStock")}.
                    </span>
                  </div>
                </div>
              </div>
              {userBusinessPackage?.id == 1 || userBusinessPackage?.id == 2 || userBusinessPackage?.id == 3 ? (
                !loadingBusinessPackage ? (
                  <div className="mt-4 flex flex-col gap-y-3">
                    <div className="flex justify-between items-center">
                      <h2 className="flex gap-x-1 text-sm md:text-2xl font-bold text-primary-color font-poppins mb-2">
                        {t("productDetail", "bulkDiscount")}
                      </h2>
                      {bulkPrice ? (
                        <div className="flex gap-x-2 py-2 md:py-4 px-0 md:px-1 rounded-xl justify-center items-center relative">
                          <span className="text-primary-color font-bold">
                            {currencySymbol}
                            {bulkPrice}
                          </span>
                          <span className="text-color-bold-gray line-through font-bold">
                            {currencySymbol}
                            {bulkDefaultPrice}
                          </span>
                          <div className="absolute -right-3 -top-3 w-10 sm:w-12 h-6 flex items-center justify-center text-xs sm:text-sm bg-green-200 text-green-700 font-bold px-2 sm:px-4 rounded">
                            {bulkDiscountRate}%
                          </div>
                        </div>
                      ) : (
                        <div className="flex gap-x-2 py-2 md:py-4 px-0 md:px-1 rounded-xl bg-gray-50 justify-center items-center relative">
                          <span className="text-primary-color font-bold">
                            {currencySymbol}
                            {totalDiscountedPrice}
                          </span>
                          <span className="text-color-bold-gray line-through font-bold">
                            {currencySymbol}
                            {totalPrice}
                          </span>
                          <div className="absolute -right-3 -top-3 w-10 sm:w-12 h-6 flex items-center justify-center text-xs sm:text-sm bg-green-200 text-green-700 px-2 sm:px-4 rounded">
                            {productDiscount}%
                          </div>
                        </div>
                      )}
                    </div>
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-x-3 sm:gap-x-6 md:gap-x-12 gap-y-10 justify-items-center">
                      {bulkDiscountsArray.map((discount: any, index: any) => {
                        return (
                          <span
                            onClick={() =>
                              handleClickBulkDiscount(index, discount)
                            }
                            key={index}
                            className={`w-32 gap-y-2 justify-between flex-col md:w-40 h-auto min-h-[95px] p-2  rounded-[10px] shadow-lg flex  items-center select-none cursor-pointer font-semibold transition-all text-[13px] text-center ${activeBulkDiscount === index
                              ? "bg-yellow-color text-primary-color border-2 border-yellow-color scale-110"
                              : "!bg-gray-200 text-primary-color bg-opacity-10"
                              }`}
                          >
                            <div className=" border-b border-white w-full flex items-center justify-center h-full text-[19px]">
                              {(
                                Math.floor(
                                  (calculatePrice(
                                    product?.product?.price,
                                    product?.product?.discount,
                                    userBusinessPackage
                                      ? userBusinessPackage?.ratio
                                      : 0
                                  ) -
                                    calculatePrice(
                                      product?.product?.price,
                                      product?.product?.discount,
                                      userBusinessPackage
                                        ? userBusinessPackage?.ratio
                                        : 0
                                    ) *
                                    (index == 0
                                      ? discount?.discount / 100
                                      : index == 1
                                        ? discount?.discount / 100
                                        : index == 2
                                          ? discount?.discount / 100
                                          : discount?.discount / 100)) *
                                  10
                                ) / 10
                              ).toFixed(1)}

                              {currencySymbol}
                            </div>
                            <div className="flex items-center justify-center h-full ">
                              {discount?.quantity} {t("productDetail", "b1")}
                              {/* {discount?.discount} {t("productDetail", "b2")} */}
                            </div>
                          </span>
                        );
                      })}
                    </div>
                    <div>
                      <p className=" text-sm text-gray-500 font-normal mt-2">
                        (Bulk purchase discounts do not apply when product
                        specifications are different)
                      </p>
                    </div>
                  </div>
                ) : (
                  // Skeleton loader if loadingBusinessPackage is true
                  <div className="mt-4 flex flex-col gap-y-3">
                    <div className="flex justify-between items-center">
                      <h2 className="flex gap-x-1 text-sm md:text-2xl font-bold text-primary-color font-poppins mb-2">
                        {t("productDetail", "bulkDiscount")}
                      </h2>
                      <div className="w-20 h-6 bg-gray-300 animate-pulse rounded-md"></div>
                    </div>
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-x-3 sm:gap-x-6 md:gap-x-12 gap-y-3">
                      {Array.from({ length: 4 }).map((_, index) => (
                        <div
                          key={index}
                          className="w-32 md:w-40 h-[75px] p-2 rounded-[10px] shadow-lg flex justify-center items-center select-none cursor-pointer bg-gray-200 animate-pulse"
                        >
                          {/* Skeleton content */}
                        </div>
                      ))}
                    </div>
                  </div>
                )
              ) : null}

              <div className=" select-none text-sm mt-2">
                <p>
                  {t("productDetail", "supplier")}:{" "}
                  <span className=" font-bold text-primary-color">
                    {product?.product.Supplier?.marketPlaceName}
                  </span>
                </p>
              </div>

              <div>
                {/* TICK */}
                <div className="flex items-center">
                  <div className="h-[48px] w-[48px] min-h-[48px] min-w-[48px] rounded-[24px] bg-[#DFDFDF] flex items-center justify-center">
                    <img
                      src={Tick}
                      className="w-[28px] object-contain h-[28px]"
                    ></img>
                  </div>
                  <p className="font-medium text-sm ml-4">
                    {product?.product?.name} {t("productDetail", "d1")}
                  </p>
                </div>

                {/* SURF */}
                <div className="flex mt-4 items-center">
                  <div className="h-[48px] w-[48px] min-h-[48px] min-w-[48px] rounded-[24px] bg-[#DFDFDF] flex items-center justify-center">
                    <img
                      src={Surf}
                      className="w-[28px] object-contain h-[28px]"
                    ></img>
                  </div>
                  <p className="font-medium text-sm ml-4">
                    {t("productDetail", "d2")}
                  </p>
                </div>

                {/* HAND OK */}
                <div className="flex mt-4 items-center">
                  <div className="h-[48px] w-[48px] min-h-[48px] min-w-[48px] rounded-[24px] bg-[#DFDFDF] flex items-center justify-center">
                    <img
                      src={Hand}
                      className="w-[28px] object-contain h-[28px]"
                    ></img>
                  </div>
                  <p className="font-medium text-sm ml-4">
                    {t("productDetail", "d3")}
                  </p>
                </div>
              </div>

              <div className="mt-8">
                <div
                  className="flex justify-between items-center cursor-pointer py-4 px-6 bg-gradient-to-r from-yellow-50 to-transparent hover:from-yellow-100 transition-all duration-300 rounded-t-lg"
                  onClick={() => setDescriptionShow(!descriptionShow)}
                >
                  <h3 className="text-lg font-medium text-gray-800">
                    {t("productDetail", "desc")}
                  </h3>
                  <IoIosArrowDown
                    className={`transform transition-transform duration-500 text-yellow-500 ${descriptionShow ? "rotate-180" : "rotate-0"
                      }`}
                    size={24}
                  />
                </div>

                <div
                  className={`transition-all duration-500 ease-in-out overflow-hidden bg-white rounded-b-lg ${descriptionShow
                    ? "max-h-[600px] opacity-100"
                    : "max-h-0 opacity-0"
                    }`}
                >
                  <div
                    className={`px-6 pb-6 space-y-6 ${styles.customScrollbar}`}
                  >
                    <div className="pt-2">
                      {/* <h4 className="font-semibold text-lg mb-4 text-gray-800">
                        {t("productDetail", "desc")}
                      </h4> */}
                      {/* <ul className="space-y-4">
                        <li className="flex items-start gap-3 group">
                          <div className="mt-1 transform transition-all duration-300 group-hover:scale-110">
                            <FaCheck className="text-yellow-500" size={18} />
                          </div>
                          <p className="text-gray-600 group-hover:text-gray-900 transition-colors duration-300">
                            {t("productDetail", "k1")}
                          </p>
                        </li>
                      </ul> */}
                    </div>
                    <div>
                      <h4 className="font-semibold text-lg mb-4 text-gray-800">
                        {t("productDetail", "desc2")}
                      </h4>
                      <p className="text-gray-600 hover:text-gray-900 transition-colors duration-300">
                        <div
                          className="mb-2 text-gray-500 dark:text-gray-400"
                          dangerouslySetInnerHTML={{
                            __html: product?.product?.features,
                          }}
                        />
                        {/*t("productDetail", "k2")*/}
                      </p>
                    </div>

                    <div>
                      <h4 className="font-semibold text-lg mb-4 text-gray-800">
                        {t("productDetail", "desc3")}
                      </h4>
                      <div className="relative">
                        <div
                          className={`text-gray-600 pr-4 ${styles.customScrollbar}`}
                        >
                          {product?.product?.description}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {product?.product?.keyword ? (
                <div className=" mt-4">
                  <p className=" text-[10px] font-semibold text-primary-color">
                    # {product?.product?.keyword}
                  </p>
                </div>
              ) : (
                <></>
              )}

              {/* CAMPAIGNS */}
              {product.dailyCampaign || product.companyCampaign
                ? (product.dailyCampaign || product.companyCampaign) && (
                  <div className="hidden md:flex flex-col items-start space-y-2 select-none ">
                    {product.dailyCampaign && (
                      <div className=" w-full">
                        <div className=" flex justify-between w-full items-center gap-x-10 ">
                          <div className="text-sm w-full">
                            {t("productDetail", "thisProduct")}{" "}
                            <span className=" text-primary-color font-bold ">
                              {t("productDetail", "daily")}
                            </span>{" "}
                            {t("productDetail", "camp")}.
                          </div>
                          <div className=" bg-white rounded text-sm p-4 border border-dotted border-primary-color font-bold flex justify-center items-center w-40 ">
                            {product.dailyCampaign.dailyCampaignTypeId ==
                              2 ? (
                              formatCompanyValue(
                                product.dailyCampaign.dailyValue
                              )
                            ) : (
                              <div className=" flex justify-between items-center gap-x-2 text-color-bold-gray">
                                <span className=" font-bold text-black">
                                  {currencySymbol}
                                  {(
                                    product.dailyCampaign.dailyValue *
                                    exchangeRate
                                  ).toFixed(1)}
                                </span>
                                <p>ek indirim.</p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                    {product.companyCampaign && (
                      <div className=" w-full">
                        <div className=" flex justify-between w-full items-center gap-x-10">
                          <div className="text-sm ">
                            {t("productDetail", "thisProduct")}{" "}
                            <span className=" text-primary-color pr-1 font-bold">
                              {
                                product.companyCampaign.supplier
                                  .marketPlaceName
                              }
                            </span>
                            {t("productDetail", "c1")}
                          </div>
                          <div className=" bg-white rounded text-sm p-4 border border-dotted border-primary-color font-bold flex flex-col justify-center items-center gap-y-1">
                            {product.companyCampaign.companyCampaignTypeId ==
                              2 ? (
                              formatCompanyValue(
                                product.companyCampaign.companyValue
                              )
                            ) : (
                              <div className=" flex justify-between items-center gap-x-2 text-color-bold-gray">
                                <span className=" font-bold text-black">
                                  {currencySymbol}
                                  {(
                                    product.companyCampaign.companyValue *
                                    exchangeRate
                                  ).toFixed(1)}
                                </span>
                                <p>{t("productDetail", "eDiscount")}</p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                )
                : null}

              {(product.dailyCampaign || product.companyCampaign) &&
                (product.dailyCampaign?.dailyCampaignTypeId === 3 ||
                  product.companyCampaign?.companyCampaignTypeId === 3) ? (
                <div className="w-full flex justify-end items-center gap-x-5">
                  <span className="line-through text-color-bold-gray">
                    {currencySymbol}
                    {product.product.price.toFixed(1)}
                  </span>
                  <span className="text-primary-color font-bold">
                    {currencySymbol}
                    {calculateCampaignPrice(product).toFixed(1)}
                  </span>
                </div>
              ) : null}
            </div>
          </div>

          {/*USER REVIEWS*/}
          {reviews?.length > 0 && (
            <div className="mt-12">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {reviews.map((review: any, index: number) => (
                  <div
                    key={index}
                    className="bg-white p-4 rounded-lg h-50"
                    style={{ boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)" }}
                  >
                    <div className="flex items-center justify-between">
                      <span className="font-semibold">
                        {review.user.firstName + " " + review.user.lastName}
                      </span>
                    </div>
                    <div className="flex items-center mt-2">
                      {renderStars(review.rating)}
                    </div>
                    <p className="text-gray-600 mt-2 overflow-y-auto h-20">
                      {review.review}
                    </p>
                    <span className="text-sm text-gray-500">
                      {formatISODate(review.createdAt)}
                    </span>
                    <div className="flex mt-2">
                      {(Object.values(review?.images) as string[]).map(
                        (image: string, index: number) =>
                          image && (
                            <img
                              key={index}
                              src={image}
                              alt={`review-${index}`}
                              className="w-20 h-20 object-cover border border-gray-300 shadow-lg rounded-lg mr-2 cursor-pointer"
                              onClick={() => handleReviewImageClick(image)}
                            />
                          )
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>

        <div className="w-[92%] md:w-[97%] mx-auto p-12 border border-[#C9C9C9] rounded-md mt-10 md:flex justify-between my-4">
          <div className="md:w-[30%] flex flex-col items-center">
            <img
              src={Truck}
              className="h-[100px] w-[120px] object-contain"
            ></img>
            <p className="mt-4 text-center">{t("productDetail", "s1")}</p>
          </div>

          <div className="w-full h-[1px] md:w-[1px] md:h-auto bg-[#C9C9C9] my-5"></div>

          <div className="md:w-[30%] flex flex-col items-center">
            <img
              src={Ticket}
              className="h-[100px] w-[120px] object-contain"
            ></img>
            <p className="mt-4 text-center">{t("productDetail", "s2")}</p>
          </div>

          <div className="w-full h-[1px] md:w-[1px] md:h-auto bg-[#C9C9C9] my-5"></div>

          <div className="md:w-[30%] flex flex-col items-center">
            <img
              src={Basket}
              className="h-[100px] w-[120px] object-contain"
            ></img>
            <p className="mt-4 text-center">{t("productDetail", "s3")}</p>
          </div>
        </div>

        {/* <img
          src={PaymentPro}
          className="w-[50%] h-[40px] mx-auto mt-10 object-contain"
        ></img> */}

        <SimilarProducts />

        {/* PRODUCT PROMOTION */}
        {showProductIntroductions && (
          <div className=" w-11/12 p-4 my-2 mb-20 mx-auto rounded-lg shadow-lg border border-gray-50">
            <ProductIntroduction detail={productIntroduction} />
          </div>
        )}

        {/* <Footer /> */}
      </main>
      <Modal
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        className="flex items-center justify-center min-h-screen"
      >
        <div className="bg-white border border-gray-300 p-6 rounded-lg shadow-lg relative max-w-md w-full">
          <button
            onClick={closeModal}
            className="absolute top-0 right-0 text-gray-500 hover:text-gray-700 focus:outline-none"
          >
            <span className="text-3xl font-semibold text-black pr-1">
              &times;
            </span>
          </button>
          <img
            src={modalImage}
            alt="Review"
            className="w-full h-auto object-contain rounded-lg"
          />
        </div>
      </Modal>

      {showSizeModal && (
        <div
          id="modal-overlay"
          onClick={handleClickOutside}
          className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50"
        >
          <div
            ref={modalRef}
            className="bg-white rounded-md shadow-lg p-6 w-[75%] h-auto max-w-full relative"
          >
            <div>
              {sizeModalImage ? (
                <img
                  src={sizeModalImage}
                  alt="Size Chart"
                  className="w-full h-auto"
                />
              ) : (
                <p className="text-gray-400 text-sm flex justify-center items-center">
                  Beden tablosuna ulaşılamadı...
                </p>
              )}
            </div>

            <button
              onClick={() => setShowSizeModal(false)}
              className="absolute top-3 right-3 text-gray-600 hover:text-red-600"
            >
              ✖
            </button>
          </div>
        </div>
      )}

      {/* Lightbox */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black/50 flex justify-center items-center z-50"
          onClick={() => setIsOpen(false)}
        >
          <div
            className=" border-4 relative"
            onClick={(e) => e.stopPropagation()}
          >
            <Lightbox
              open={isOpen}
              close={() => setIsOpen(false)}
              slides={
                product?.product?.images[1] == "" ?
                  product?.product?.images
                    ?.filter((_: any, index: number) => index > 1 || product?.product?.images[1] != "")
                    ?.map((image: string) => ({ src: image }))
                  :
                  product?.product?.images
                    ?.filter((_: any, index: number) => index > 0 || product?.product?.images[1] != "")
                    ?.map((image: string) => ({ src: image }))
              }
              index={photoIndex}
              styles={{ container: { backgroundColor: "#F9F9F9" } }}
              className=" "
              toolbar={{
                buttons: [
                  <button
                    onClick={() => setIsOpen(false)}
                    type="button"
                    className=" text-red-600 hover:scale-90 transition-transform absolute  -left-10 md:-left-20 top-40 md:top-20"
                  >
                    <FaRegWindowClose size={35} />
                  </button>,
                ],
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default ProductDetail;
